import { callKakaostyleMktFunction } from '../../callKakaostyleMktFunction';

export const logAppsFlyer = (eventName: string, parameters?: object) => {
  callKakaostyleMktFunction('logAppsFlyer', eventName)(parameters);
};
